import { Menu, MenuButton, MenuList, Portal } from '@chakra-ui/react';
import { ChevronDownIcon, TickMarkIcon } from '@sketchnote/icons';
import { Fragment, useEffect } from 'react';

import { useAgileStore } from '../../store';

export const SprintSelector = () => {
  const { activeSprints, selectedSprintIds, setSelectedSprintIds } = useAgileStore((s) => ({
    activeSprints: s.activeSprints,
    selectedSprintIds: s.selectedSprintIds,
    setSelectedSprintIds: s.setSelectedSprintIds,
  }));

  const handleSprintSelection = async (id: string) => {
    if (selectedSprintIds.includes(id)) {
      setSelectedSprintIds(selectedSprintIds.filter((sprintId) => sprintId !== id));
    } else {
      setSelectedSprintIds([...selectedSprintIds, id]);
    }
  };

  useEffect(() => {
    const unknownSprint = selectedSprintIds.find(
      (sprintId) => !activeSprints.find((s) => s._id === sprintId)
    );
    if (unknownSprint) {
      setSelectedSprintIds([]);
    }
  }, [activeSprints]);

  return (
    <Fragment>
      <Menu>
        <MenuButton
          as="div"
          className="flex items-center justify-center text-sm mr-12 cursor-pointer text-gray-500"
        >
          <div className="flex gap-4">
            <ChevronDownIcon color="#878A92" wrapperClass="mt-3" />
            <div>
              {selectedSprintIds.length === 0 || selectedSprintIds.length === activeSprints.length
                ? 'All sprints'
                : 'Custom sprints'}
            </div>
          </div>
        </MenuButton>

        <Portal>
          <div className="more-menu-popover">
            <MenuList>
              <div
                className="bg-white p-6 flex flex-col gap-0 justify-center cursor-pointer"
                style={{
                  boxShadow: ' 0px 2px 12px rgba(19, 23, 32, 0.08)',
                  borderRadius: '8px',
                  zIndex: '20',
                }}
              >
                <div
                  style={{
                    maxHeight: '300px',
                    overflow: 'auto',
                  }}
                >
                  {activeSprints?.map((sprint) => {
                    const isChecked = selectedSprintIds.includes(sprint._id);
                    return (
                      <div
                        key={sprint._id}
                        className="flex gap-8 px-10 h-40 items-center hover:bg-gray-100 min-w-200"
                        onClick={handleSprintSelection.bind(null, sprint._id)}
                      >
                        <div className="flex justify-between w-full">
                          <p className="text-sm font-regular text-gray-999 leading-20">
                            {sprint.title}
                          </p>
                          {isChecked && <TickMarkIcon className="text-blue-600 mt-2" />}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </MenuList>
          </div>
        </Portal>
      </Menu>
    </Fragment>
  );
};
